window.woord = [];
window.woordHasRegisteredOnchangeContent = [];

window.Woord = class Woord {
    uid = null;
    velden = [];
    vContentEl = null;
    formContentEl = null;
    formVeldenEl = null;
    propertiesVeldenContainerEl = null;

    constructor(uid, velden) {
        //console.log('constructor', velden);
        this.uid = uid;
        this.velden = velden;
        this.vContentEl = $('#v-woord-' + this.uid + '-content');
        this.formContentEl = $('#woord-' + this.uid + '-content');
        this.formVeldenEl = $('#woord-' + this.uid + '-velden');
        this.propertiesVeldenContainerEl = $('#woord-' + this.uid + '-veld-container');
        this.renderVeldenContainerEl();
        this.contentCheckVelden();
        this.syncContent();
        this.syncVelden();
        this.registerOnchangeContent();
        this.registerVContentVeldEvents();
    }


    registerOnchangeContent() {
        if (window.woordHasRegisteredOnchangeContent.includes(this.uid)) {

        } else {
            window.woordHasRegisteredOnchangeContent.push(this.uid);
        }

        const contentSelector = '#v-woord-' + this.uid + '-content';
        const $contentEl = $(contentSelector);

        if ($contentEl.data('inputEventRegistered')) {
            return;
        }

        $contentEl.on('input', () => {
            console.log("input detected");
            setTimeout(function () {
                const $closestVraag = $contentEl.closest(".vraag");
                const uid = $closestVraag.attr('data-uid');
                window.woord[uid].contentCheckVelden();
                window.woord[uid].syncContent();
                window.woord[uid].syncVelden();
            }, 10);
        });

        $contentEl.data('inputEventRegistered', true);
    }

    registerOnchangeContenttttt() {
        if (window.woordHasRegisteredOnchangeContent.includes(this.uid)) {
            //return;
        } else {
            window.woordHasRegisteredOnchangeContent.push(this.uid);
        }

        var elementId = '#v-woord-' + this.uid + '-content';
        var targetNode = document.querySelector(elementId);

        if (targetNode) {
            var observer = new MutationObserver(function(mutationsList, observer) {
                mutationsList.forEach(function(mutation) {
                    if (mutation.type === 'childList' || mutation.type === 'subtree') {
                        var _this = mutation.target;

                        setTimeout(function () {
                            var uid = $(_this).closest(".vraag").attr('data-uid');
                            window.woord[uid].contentCheckVelden();
                            window.woord[uid].syncContent();
                            this.syncVelden();
                        }, 0);
                    }
                });
            });

            // Configuration of the observer:
            var config = { childList: true, subtree: true };

            // Start observing the target node for configured mutations
            observer.observe(targetNode, config);
        }

        /*
        $('body').on('DOMSubtreeModified', '#v-woord-' + this.uid + '-content', function () {
          var _this = this;

          //console.log('DOMSubtreeModified', $(this).closest(".vraag").attr('data-uid'));
          setTimeout(function () {
            window.woord[$(_this).closest(".vraag").attr('data-uid')].contentCheckVelden();
            window.woord[$(_this).closest(".vraag").attr('data-uid')].syncContent();
          }, 0);
        }); */
    }

    registerVContentVeldEvents() {
        this.vContentEl.on('click', '.v-woord__veld', function() {
            woord[$(this).closest(".vraag").attr("data-uid")].onfocusVeld($(this).attr("data-uid"));
        });
    }

    setContent(content) {
        this.vContentEl.html(content);
    }

    setVelden(velden) {
        //console.log("setVelden", velden);
        this.velden = velden;
    }

    syncContent() {
        this.formContentEl.val(this.vContentEl.html());
    }

    syncVelden() {
        //console.log('syncVelden()', this.velden);
        this.formVeldenEl.val(JSON.stringify(this.velden));
    }

    contentCheckVelden() {
        //console.log('START: contentCheckVelden()', this.velden);
        //get all veld uid and type from this.vContentEl and rebuild this.velden

        let currentVelden = this.velden;
        let newVelden = [];
        let uid, type, currentVeld;
        this.vContentEl.find(".v-woord__veld").each(function() {
            $(this).removeClass("focus");
            uid = $(this).attr("data-uid");
            type = $(this).attr("data-type");
            //console.log(uid);
            //console.log(type);
            if (uid === undefined || type === undefined) return;
            currentVeld = currentVelden.filter(cv => cv.uid === uid);
            if (currentVeld.length) {
                newVelden.push(currentVeld[0]);
                return;
            }
            newVelden.push({uid: uid, juiste_antwoord: '', placeholder: '', aantal_antwoordregels: 1, type: type, alleen_lezen: 0});
        });
        this.velden = newVelden;
        //console.log('DONE: contentCheckVelden()', this.velden);
        this.renderVeldenContainerEl();
        this.syncVelden();

    }

    bold() {
        document.execCommand('bold', false);
    }

    italic() {
        document.execCommand('italic', false);
    }

    underline() {
        document.execCommand('underline', false);
    }

    renderVeldenContainerEl() {
        //console.log('renderVeldenContainerEl', this.velden);
        this.propertiesVeldenContainerEl.html('');
        this.velden.forEach(veld => {
            this.addVeldPropertiesEl(veld);
        });
    }

    addVeld(type) {
        //console.log("addVeld")
        let uid = window.uid();
        this.addVeldEl(uid, type);
        this.contentCheckVelden();
        this.syncContent();
        this.syncVelden();
    }

    addVeldEl(uid, type) {
        //console.log("addVeldEl")
        $("#v-woord-" + this.uid + "-content").focus();
        pasteHtmlAtCursor(this.getVeldHtml(uid, type));
    }

    deleteVeld(uid) {
        //console.log("deleteVeld")
        this.velden = this.velden.filter(v => v.uid !== uid);
        this.syncVelden();
        this.deleteVeldEl(uid);
    }

    deleteVeldEl(uid) {
        $('#woord-' + this.uid + '-veld-' + uid + '-items').remove();
    }

    addVeldPropertiesEl(veld) {
        let alleenLezenChecked = veld.alleen_lezen ? 'checked' : '';
        let veldPropertiesHtml = '' +
            '<div class="woord__veld" id="woord-' + this.uid +'-veld-' + veld.uid +'" data-type="' + veld.type + '">\n' +
            '    <div class="form-group">\n' +
            '        <label for="woord-' + this.uid +'-veld-' + veld.uid +'-juiste_antwoord">Juiste antwoord</label>\n' +
            '            <input id="woord-' + this.uid +'-veld-' + veld.uid +'-juiste_antwoord" class="form-control" type="text" value="' + veld.juiste_antwoord + '" onfocus="woord[\'' + this.uid + '\'].onfocusVeldProperties(\'' + veld.uid + '\')" onblur="woord[\'' + this.uid + '\'].onblurVeldProperties(\'' + veld.uid + '\')" onchange="woord[\'' + this.uid + '\'].onchangeVeldJuisteAntwoord(\'' + veld.uid + '\', this.value)">\n' +
            '        <div class="validator-message"></div>\n' +
            '    </div>\n' +
            '    <div class="form-group">\n' +
            '        <label for="woord-' + this.uid +'-veld-' + veld.uid +'-placeholder">Placeholder</label>\n' +
            '            <input id="woord-' + this.uid +'-veld-' + veld.uid +'-placeholder" class="form-control" type="text" value="' + veld.placeholder + '" onfocus="woord[\'' + this.uid + '\'].onfocusVeldProperties(\'' + veld.uid + '\')" onblur="woord[\'' + this.uid + '\'].onblurVeldProperties(\'' + veld.uid + '\')" onchange="woord[\'' + this.uid + '\'].onchangeVeldPlaceholder(\'' + veld.uid + '\', this.value)">\n' +
            '        <div class="validator-message"></div>\n' +
            '    </div>\n' +
            '    <div class="form-group">\n' +
            '        <label for="woord-' + this.uid +'-veld-' + veld.uid +'-type">Type</label>\n' +
            '        <select id="woord-' + this.uid +'-veld-' + veld.uid +'-type" class="form-control" onfocus="woord[\'' + this.uid + '\'].onfocusVeldProperties(\'' + veld.uid + '\')" onblur="woord[\'' + this.uid + '\'].onblurVeldProperties(\'' + veld.uid + '\')" onchange="woord[\'' + this.uid + '\'].onchangeVeldType(\'' + veld.uid + '\', this.value)"><option value="1" ' + this.selectOptionSelected(1, veld.type) + '>Klein</option><option value="2" ' + this.selectOptionSelected(2, veld.type) + '>Middel</option><option value="3" ' + this.selectOptionSelected(3, veld.type) + '>Groot</option><option value="4" ' + this.selectOptionSelected(4, veld.type) + '>Meerdere regels</option></select>\n' +
            '        <div class="validator-message"></div>\n' +
            '    </div>\n' +
            '    <div class="form-group woord-veld-aantal_antwoordregels">\n' +
            '        <label for="woord-' + this.uid +'-veld-' + veld.uid +'-aantal_antwoordregels">Aantal antwoordregels</label>\n' +
            '        <select id="woord-' + this.uid +'-veld-' + veld.uid +'-aantal_antwoordregels" class="form-control" onfocus="woord[\'' + this.uid + '\'].onfocusVeldProperties(\'' + veld.uid + '\')" onblur="woord[\'' + this.uid + '\'].onblurVeldProperties(\'' + veld.uid + '\')" onchange="woord[\'' + this.uid + '\'].onchangeVeldAantalAntwoordregels(\'' + veld.uid + '\', this.value)"><option value="" selected="selected"></option><option value="1" ' + this.selectOptionSelected(1, veld.aantal_antwoordregels) + '>1</option><option value="2" ' + this.selectOptionSelected(2, veld.aantal_antwoordregels) + '>2</option><option value="3" ' + this.selectOptionSelected(3, veld.aantal_antwoordregels) + '>3</option><option value="4" ' + this.selectOptionSelected(4, veld.aantal_antwoordregels) + '>4</option><option value="5" ' + this.selectOptionSelected(5, veld.aantal_antwoordregels) + '>5</option><option value="6" ' + this.selectOptionSelected(6, veld.aantal_antwoordregels) + '>6</option><option value="7" ' + this.selectOptionSelected(7, veld.aantal_antwoordregels) + '>7</option><option value="8" ' + this.selectOptionSelected(8, veld.aantal_antwoordregels) + '>8</option><option value="9" ' + this.selectOptionSelected(9, veld.aantal_antwoordregels) + '>9</option><option value="10" ' + this.selectOptionSelected(10, veld.aantal_antwoordregels) + '>10</option><option value="11" ' + this.selectOptionSelected(11, veld.aantal_antwoordregels) + '>11</option><option value="12" ' + this.selectOptionSelected(12, veld.aantal_antwoordregels) + '>12</option><option value="13" ' + this.selectOptionSelected(13, veld.aantal_antwoordregels) + '>13</option><option value="14" ' + this.selectOptionSelected(14, veld.aantal_antwoordregels) + '>14</option><option value="15" ' + this.selectOptionSelected(15, veld.aantal_antwoordregels) + '>15</option><option value="16" ' + this.selectOptionSelected(16, veld.aantal_antwoordregels) + '>16</option><option value="17" ' + this.selectOptionSelected(17, veld.aantal_antwoordregels) + '>17</option><option value="18" ' + this.selectOptionSelected(18, veld.aantal_antwoordregels) + '>18</option><option value="19" ' + this.selectOptionSelected(19, veld.aantal_antwoordregels) + '>19</option><option value="20" ' + this.selectOptionSelected(20, veld.aantal_antwoordregels) + '>20</option></select>\n' +
            '        <div class="validator-message"></div>\n' +
            '    </div>\n' +
            '    <div class="form-check form-check-inline mb-2">\n' +
            '        <input id="woord-' + this.uid +'-veld-' + veld.uid +'-alleen_lezen1" class="form-check-input" role="button" type="checkbox" value="1" onclick="woord[\'' + this.uid + '\'].onclickVeldAlleenLezen(\'' + veld.uid + '\', this.checked)" ' + alleenLezenChecked + '>\n' +
            '        <label class="form-check-label" for="woord-' + this.uid +'-veld-' + veld.uid +'-alleen_lezen1" role="button">Alleen lezen</label>\n' +
            '    </div>\n' +
            '</div>';
        this.propertiesVeldenContainerEl.append(veldPropertiesHtml);
    }

    selectOptionSelected(optionValue, value) {
        if (optionValue == value) {
            return 'selected';
        }
        return '';
    }

    onfocusVeld(uid) {
        //console.log('onfocusVeld', uid);
        this.vContentEl.find("#v-woord-" + this.uid + "-veld-" + uid).removeClass("focus");
        this.vContentEl.find("#v-woord-" + this.uid + "-veld-" + uid).addClass("focus");
        $("#woord-" + this.uid + "-veld-" + uid).removeClass("focus");
        setTimeout(() => {
            $("#woord-" + this.uid + "-veld-" + uid).addClass("focus").find("input").first().focus();
        }, 0);
    }

    onblurVeld(uid) {
        //console.log('onfocusVeld', uid);
        this.vContentEl.find("#v-woord-" + this.uid + "-veld-" + uid).removeClass("focus");
        $("#woord-" + this.uid + "-veld-" + uid).removeClass("focus");
    }

    onfocusVeldProperties(uid) {
        //console.log('onfocusVeldTitel', uid);
        this.vContentEl.find("#v-woord-" + this.uid + "-veld-" + uid).removeClass("focus");
        this.vContentEl.find("#v-woord-" + this.uid + "-veld-" + uid).addClass("focus");
        $("#woord-" + this.uid + "-veld-" + uid).removeClass("focus");
        $("#woord-" + this.uid + "-veld-" + uid).addClass("focus");
    }

    onblurVeldProperties(uid) {
        //console.log('onblurVeldTitel');
        this.vContentEl.find("#v-woord-" + this.uid + "-veld-" + uid).removeClass("focus");
        $("#woord-" + this.uid + "-veld-" + uid).removeClass("focus");
    }

    onchangeVeldJuisteAntwoord(uid, juiste_antwoord) {
        $("#v-woord-"+this.uid+"-veld-"+uid).prop("placeholder", juiste_antwoord);
        this.syncContent();
        this.velden = this.velden.map(v => {
            if (v.uid === uid) {
                return {uid: v.uid, juiste_antwoord: juiste_antwoord, placeholder: v.placeholder, aantal_antwoordregels: v.aantal_antwoordregels, type: v.type, alleen_lezen: v.alleen_lezen};
            }
            return v;
        });
        this.syncVelden();
    }

    onchangeVeldPlaceholder(uid, placeholder) {
        //console.log('onchangeVeldPlaceholder', uid, placeholder);
        this.velden = this.velden.map(v => {
            if (v.uid === uid) {
                return {uid: v.uid, juiste_antwoord: v.juiste_antwoord, placeholder: placeholder, aantal_antwoordregels: v.aantal_antwoordregels, type: v.type, alleen_lezen: v.alleen_lezen};
            }
            return v;
        });
        this.syncVelden();
    }

    onchangeVeldAantalAntwoordregels(uid, aantal_antwoordregels) {
        //console.log('onchangeVeldAantalAntwoordregels', uid, aantal_antwoordregels);
        this.velden = this.velden.map(v => {
            if (v.uid === uid) {
                return {uid: v.uid, juiste_antwoord: v.juiste_antwoord, placeholder: v.placeholder, aantal_antwoordregels: aantal_antwoordregels, type: v.type, alleen_lezen: v.alleen_lezen};
            }
            return v;
        });
        this.syncVelden();
    }

    onchangeVeldType(uid, type) {
        //console.log('onchangeVeldType', uid, type);
        //update this.velden
        this.velden = this.velden.map(v => {
            if (v.uid === uid) {
                return {uid: v.uid, juiste_antwoord: v.juiste_antwoord, placeholder: v.placeholder, aantal_antwoordregels: v.aantal_antwoordregels, type: type, alleen_lezen: v.alleen_lezen};
            }
            return v;
        });
        //update vContentEl veldEl data-type
        let veldEl = this.vContentEl.find("#v-woord-" + this.uid + "-veld-" + uid);
        if (veldEl) veldEl.replaceWith(this.getVeldHtml(uid, type));

        $("#v-woord-"+this.uid+"-veld-"+uid).prop("placeholder", $("#woord-"+this.uid+"-veld-"+uid+"-juiste_antwoord").val());

        //update veld properties data-type
        $("#woord-" + this.uid + "-veld-" + uid).attr('data-type', type);
        console.log(" bbbb");

        this.syncContent();
        this.syncVelden();
        this.contentCheckVelden();
    }

    getVeldHtml(uid, type) {
        //console.log('getVeldHtml', uid, type);
        if (type == 1 || type == 2 || type == 3) {
            return '<input type="text" class="v-woord__veld" id="v-woord-' + this.uid + '-veld-' + uid + '" data-uid="' + uid + '" data-type="' + type + '" readonly />';
        } else if (type == 4) {
            return '<textarea class="v-woord__veld" id="v-woord-' + this.uid + '-veld-' + uid + '" data-uid="' + uid + '" data-type="' + type + '" readonly />';
        }
        return '';
    }

    onclickVeldAlleenLezen(uid, alleen_lezen) {
        //console.log('onchangeVeldPlaceholder', uid, alleen_lezen);
        this.velden = this.velden.map(v => {
            if (v.uid === uid) {
                return {uid: v.uid, juiste_antwoord: v.juiste_antwoord, placeholder: v.placeholder, aantal_antwoordregels: v.aantal_antwoordregels, type: v.type, alleen_lezen: alleen_lezen ? 1 : 0};
            }
            return v;
        });
        this.syncVelden();
    }
}
